import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminLogin from "@/pages/AdminLogin";
import StudentLayout from "@/pages/student/StudentLayout";
import Studio from "@/pages/student/Studio";
import Works from "@/pages/student/Works";
import StudentChat from "@/pages/student/StudentChat";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminChat from "@/pages/admin/AdminChat";
import AdminArchive from "@/pages/admin/AdminArchive";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute role="student"><StudentLayout /></ProtectedRoute>}>
              <Route path="/studio" element={<Studio />} />
              <Route path="/lavori" element={<Works />} />
              <Route path="/chat" element={<StudentChat />} />
            </Route>
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminUsers />} />
              <Route path="chat" element={<AdminChat />} />
              <Route path="archivio" element={<AdminArchive />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
